var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffsitefailover1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4211_1932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.3281 15.2344H1.67188M41.1286 3.51562H1.67188V74.1406H28.5509",
    stroke: "#7A3805",
    strokeWidth: 2.34375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4491 74.1406H79.3281V5.85938C79.3281 3.27047 77.2295 1.17188 74.6406 1.17188H45.1875C42.5986 1.17188 40.5 3.27047 40.5 5.85938V10.5469H11.0469M1.67188 10.5469H6.35938M70.6395 9.86047L73.9542 6.54578M70.6395 6.54578L73.9542 9.86047M15.7344 69.4531H24.9508",
    stroke: "#7A3805",
    strokeWidth: 2.34375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0492 69.4531H74.6406V19.9219H6.35938V69.4531H11.0469",
    stroke: "#7A3805",
    strokeWidth: 2.34375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9529 50.5465C29.9529 48.3802 29.463 46.3283 28.5882 44.4955C27.5405 42.3008 24.6424 41.7944 22.9227 43.5141C21.8571 44.5798 21.6151 46.1935 22.2565 47.5572C22.696 48.4923 22.9231 49.5131 22.9216 50.5463V61.2496C22.9216 70.9577 30.7916 78.8277 40.4998 78.8277C50.2079 78.8277 58.0779 70.9577 58.0779 61.2496V50.5465C58.0779 48.6049 56.5038 47.0308 54.5623 47.0308C52.6207 47.0308 51.0466 48.6049 51.0466 50.5465",
    stroke: "#7A3805",
    strokeWidth: 2.34375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0156 50.5469V44.6875C44.0156 42.7459 42.4416 41.1719 40.5 41.1719C38.5584 41.1719 36.9844 42.7459 36.9844 44.6875M51.0469 50.5469V47.0312C51.0469 45.0897 49.4728 43.5156 47.5312 43.5156C45.5897 43.5156 44.0156 45.0897 44.0156 47.0312M36.9844 50.5469V28.125C36.9844 26.1834 35.4103 24.6094 33.4688 24.6094C31.5272 24.6094 29.9531 26.1834 29.9531 28.125V56.4062C29.9531 57.7006 28.9038 58.75 27.6094 58.75",
    stroke: "#7A3805",
    strokeWidth: 2.34375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4211_1932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffsitefailover1);
export default __webpack_public_path__ + "static/media/offsitefailover1.6cc7e07da2a056514535862e228bc39a.svg";
export { ForwardRef as ReactComponent };